﻿///<reference path="main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
	'use strict';

	let moreLinks = app.$$( '.bio-view-more' );

	app.$.forEach( moreLinks, link => {
		link.addEventListener( 'click', e => {
			let prev = link.parentNode;
			let full = prev.nextElementSibling;
			prev.classList.add( 'hidden' );
			full.classList.remove( 'hidden' );
			e.preventDefault();
		} );
	} );

}( document ) );